module.exports = __webpack_public_path__ + "static/img/dpic.dcdb616.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theresource/IdcFudi/dpic.png
// module id = NSKd
// module chunks = 0